import { Expose } from "class-transformer";
import { IsString, IsOptional, IsBoolean } from "class-validator";

export class AttributeInfo {
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  code!: string;
  @Expose()
  @IsString()
  @IsOptional()
  defaultValue!: string | null;
  @Expose()
  @IsBoolean()
  isRequired!: boolean;
  @Expose()
  @IsBoolean()
  isPrintable!: boolean;
}
